import { faFileSignature } from '@fortawesome/pro-regular-svg-icons';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Agreement } from 'types/Agreement';

import classes from './AgreementCard.module.scss';

interface AgreementCardProps {
    checked?: boolean;
    agreement: Agreement;
    onClick?: (agreement: Agreement) => void;
}

export const AgreementCard: React.FC<AgreementCardProps> = props => {
    return (
        <div
            className={classes.root}
            data-checked={props.checked}
            onClick={() => props.onClick?.(props.agreement)}
        >
            {props.checked && (
                <div className={classes.checkedIcon}>
                    <FontAwesomeIcon icon={faCheckCircle} />
                </div>
            )}

            <div className={classes.icon}>
                <FontAwesomeIcon icon={faFileSignature} />
            </div>

            <div className={classes.content}>
                <p className={classes.title}>{props.agreement.title}</p>
                <span className={classes.label}>Read & Sign</span>
            </div>
        </div>
    );
};
